import { createActions } from 'redux-actions'

export default createActions('CALCULATE')
